import CONSTANT from '../config/constant'
import scrollHandler from '../motion/ScrollHandler'

export default class Utility {
  static getUnixTime() {
    return (new Date()).getTime()
  }

  static getRandomRange(min, max) {
    return Math.random() * (max - min) + min
  }

  static setStyleToElements(elements, styles) {
    for (let i = 0, length = elements.length; i < length; i++) {
      Object.keys(styles).forEach((key) => {
        elements[i].style[key] = styles[key]
      })
    }
  }

  static translateXY(element, x, y) {
    const t = `translate3d(${x}px, ${y}px, 0)`
    const s = element.style

    s['transform'] = t
    s['webkitTransform'] = t
  }

  static scale(element, x, y) {
    const t = `scale(${x}, ${y})`
    const s = element.style

    s['transform'] = t
    s['webkitTransform'] = t
  }

  // https://github.com/jquery/jquery/blob/bf3a43eff8682b59cec785be6003753fa4b93706/src/offset.js
  static getElementTop(elm) {
    return elm.getBoundingClientRect().top + window.pageYOffset
  }

  static getElementCenter(elm) {
    return this.getElementTop(elm) + elm.clientHeight / 2
  }

  static getElementBottom(elm) {
    return this.getElementTop(elm) + elm.clientHeight
  }

  static inArea(windowTop, windowBottom, elementTop, elementBottom) {
    if (elementTop <= windowBottom && elementBottom >= windowTop) {
      return true
    } else {
      return false
    }
  }

  static isPassed(windowBottom, elementTop, offset = 0) {
    if (windowBottom >= elementTop + offset) {
      return true
    } else {
      return false
    }
  }

  static getRandomFloat(min, max) {
    return Math.random() * (max - min) + min
  }
}


// WEBPACK FOOTER //
// ./src/assets/js/utility/Utility.js